import { AutoComplete, Button, Input, Select, Space, Tag, Tooltip } from "antd";
import type { ClearValuesType, HandleConfirmInputType, InputWithTagsType } from "./types/InputWithTagsType";
import { useState } from "react";
import validator from "../../../../shared/validators/filterValueValidator";
import "./styles/inputWithTags.css";
import { splitString } from "../../../../utils";

const InputWithTags: React.FC<InputWithTagsType> = ({
    curFilter,
    disabled,
    appliedFilters,
    updateFilter
}) => {
    const [inputValue, setInputValue] = useState("");

    const curValues = appliedFilters.find(f => f.key === curFilter.key)?.values || [];
    const filtrType = appliedFilters.find(f => f.key === curFilter.key)?.filtration_type;

    const clearValues: ClearValuesType = (value) => {
        const newValues = curValues.filter(f => f !== value)
        updateFilter(curFilter.key, newValues, filtrType)
    }

    const handleConfirmInput: HandleConfirmInputType = (
        valueFromAutoComplete,
    ) => {
        const curValue = valueFromAutoComplete || inputValue;
        const splittedArray = splitString(curValue);

        const rawValidArray = curFilter.shouldSplitInputText
            ? splittedArray
                .flatMap((item) => validator.validate(item))
                .filter(Boolean)
            : [validator.validate(curValue)].filter(Boolean);

        const validValueArray = [...new Set(rawValidArray)];

        const uniqueNewValues = validValueArray.filter(
            (item) => !curValues.includes(item),
        );

        setInputValue("");

        if (!validValueArray.length || !uniqueNewValues.length) return;

        updateFilter(curFilter.key, [...curValues, ...uniqueNewValues], filtrType);
    };

    const showTags = curFilter.type !== "select" && !disabled;

    const objNamed: Record<string, string> = {
        llm: "Unverified",
        finals: "Verified",
        validated: "Validated",
    };

    return (
        <>
            <div className="select-container">
                {showTags && (
                    <Space wrap style={{ display: "flex" }}>
                        {curValues.map((val) => (
                            <Tag
                                key={val}
                                closable
                                onClose={() => clearValues(val)}
                                color="blue"
                            >
                                {val}
                            </Tag>
                        ))}
                    </Space>
                )}

                {curFilter.type === "input" && (
                    <Tooltip title={inputValue} overlayStyle={{ maxWidth: 800 }}>
                        <Input
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            style={{ width: 160, minWidth: 160 }}
                            onPressEnter={() => handleConfirmInput()}
                            onBlur={() => handleConfirmInput()}
                            disabled={disabled}
                        />
                    </Tooltip>
                )}
                {curFilter.type === "dropdown" && (
                    <AutoComplete
                        placeholder={"Choose Classification"}
                        style={{ width: 160 }}
                        dropdownStyle={{ zIndex: 900 }}
                        value={inputValue}
                        options={curFilter.filterOptions.map(opt => ({ value: opt }))}
                        onChange={val => setInputValue(val)}
                        filterOption={(inputValue, option) => {
                            if (!option?.value) return false;
                            return option.value.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                        onSelect={val => handleConfirmInput(val)}
                        disabled={disabled}
                    />
                )}

                {curFilter.type === "select" && (
                    <Select
                        placeholder={"Choose State"}
                        className="select-source"
                        style={{ minWidth: 160 }}
                        dropdownStyle={{ zIndex: 900 }}
                        mode="multiple"
                        value={curValues}
                        options={curFilter.filterOptions.map(opt => ({
                            value: opt,
                            label: objNamed[opt],
                        }))}
                        onChange={(values) => {
                            updateFilter(curFilter.key, values, filtrType);
                        }}
                        filterOption={(inputValue, option) => {
                            if (!option?.value) return false;
                            return option.value.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                        onSelect={val => handleConfirmInput(val)}
                        popupRender={(menu) => (
                            <>
                                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                    <Button
                                        size="small"
                                        className="select-source-btn"
                                        onClick={() => {
                                            updateFilter(
                                                curFilter.key,
                                                curFilter.filterOptions,
                                                filtrType
                                            )
                                        }}
                                        style={{ border: "none", padding: 12 }}
                                    >
                                        Select all
                                    </Button>

                                    <Button
                                        size="small"
                                        className="select-source-btn"
                                        onClick={() => {
                                            updateFilter(curFilter.key, [], filtrType)
                                        }}
                                        style={{ border: "none", padding: 12 }}
                                    >
                                        Deselect all
                                    </Button>
                                    <span style={{ fontSize: "10px", color: "rgba(0,0,0,0.5)" }}>Advanced DM</span>
                                </div>

                                {menu}
                            </>
                        )}
                        disabled={disabled}
                    />
                )}
            </div >
        </>
    )
}

export default InputWithTags;